export enum STOCK_ITEM_LIST_DOMAIN {
  LIST = 'list',
  CURRENT_PAGE_NUMBER = 'currentPage',
  BY_PAGE = 'byPage',
  TOTAL_COUNT = 'totalCount',
  QUERY = 'query',
  IS_DESCENDING = 'isDescending',
  RUBRICS = 'rubrics',
}

export const STOCK_ITEM_LIST_DOMAIN_KEY = 'stockItemList';
